if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

      this.hideErrors = this.dataset.hideErrors === 'true';
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
      
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          
          if (response.status) {
            
            publish(PUB_SUB_EVENTS.cartError, {source: 'product-form', productVariantId: formData.get('id'), errors: response.description, message: response.message});
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form', productVariantId: formData.get('id')});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            
            var $this=this;
             $this.cart.renderContents(response);
            console.log(response);   
   // alert("form")
           $.ajax({
                  url: '/cart.js',
                  dataType: 'json',
                  success: function(cart) {
                    console.log(cart);
                    var total_price=cart.total_price;
                    total_price=parseFloat(total_price/100)
                   // alert("form == "+total_price);
                    
                    // if(total_price >= 749 && total_price <= 1248 && cart.attributes.id != 47243158683970)
                    // {
                    //  //alert("travel form");
                      
                    //     var sec_attribute = 47243158683970;
                    //     var attr_id=cart.attributes.id;
                    //     console.log("second=="+attr_id);
                      
                    //     console.log(attr_id);
                    //      if(typeof attr_id !== "undefined")
                    //       {
                    //         // $.ajax({
                    //         //   type: 'POST',
                    //         //   url: '/cart/change.js',
                    //         //   dataType: 'json',
                    //         //   data: {
                    //         //       quantity: 0,
                    //         //       id: attr_id
                    //         //   },
                    //         //   success: function (data){                        
                    //         //     jQuery('.ct_'+attr_id).closest('.cart-item').remove();
                    //         //   }
                    //         //   })
                    //        //alert("form "+attr_id)
                            
                    //       }

                    //         $.ajax({
                    //           type: 'POST',
                    //           url: '/cart/update.js',
                    //           dataType: 'json',
                    //            data:{
                    //              attributes: {
                    //                    id: "47243158683970"
                    //               }
                    //            },
                    //       success: function (data){
                    //         if(cart.attributes.id != 47243158683970)
                    //         {
                    //           jQuery('.ct_47243158683970').trigger('click');
                    //          // alert("from add tocart 970");
                    //           var sec_attribute = 47243158683970;
                    //           $("body").append('<product-form class="product-form dev_ap" style="display:none;"><div class="product-form__error-message-wrapper" role="alert" hidden=""><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path></svg><span class="product-form__error-message"></span></div><form method="post" action="/cart/add" id="product-form-quickadd-template--14503160479790__main" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="'+sec_attribute+'" class="product-variant-id"><div class="bold_options" ></div><div class="product-form__buttons"><button id="ProductSubmitButton-quickadd-template--14503160479790__main" type="submit" name="add" class="product-form__submit button button--full-width button--primary" aria-haspopup="dialog"><span class="dev_upsell_click">Add to cart</span><div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></button></div></form></product-form>');
                    //           $(document).find('.dev_upsell_click').trigger("click");
                    //           $("body").find('.dev_ap').remove();
                    //         }
                    //       }
                    //       })
                              
                    //       // fetch('/cart/update.js', {
                    //       //     method: "POST",
                    //       //     headers: {
                    //       //         'X-Requested-With': 'XMLHttpRequest',
                    //       //         'Content-Type': 'application/json;'
                    //       //     },
                    //       //     body: JSON.stringify({
                    //       //         attributes: {
                    //       //              id: "47243158683970"
                    //       //         }
                    //       //     })
                    //       // }).then((response) => {
                    //       //   if(cart.attributes.id != 47243158683970)
                    //       //   {
                              
                    //       //     var sec_attribute = 47243158683970;
                    //       //     $("body").append('<product-form class="product-form dev_ap" style="display:none;"><div class="product-form__error-message-wrapper" role="alert" hidden=""><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path></svg><span class="product-form__error-message"></span></div><form method="post" action="/cart/add" id="product-form-quickadd-template--14503160479790__main" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="'+sec_attribute+'" class="product-variant-id"><div class="bold_options" ></div><div class="product-form__buttons"><button id="ProductSubmitButton-quickadd-template--14503160479790__main" type="submit" name="add" class="product-form__submit button button--full-width button--primary" aria-haspopup="dialog"><span class="dev_upsell_click">Add to cart</span><div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></button></div></form></product-form>');
                    //       //     $(document).find('.dev_upsell_click').trigger("click");
                    //       //     $("body").find('.dev_ap').remove();
                    //       //   }
                    //       // });
                    // }
                    // else 
                    if(total_price >= 999 && cart.attributes.id != 47243158683970)
                    { 
                       //alert("totte form");
                        var attr_id=cart.attributes.id;
                        console.log("third=="+attr_id);
                      if(typeof attr_id !== "undefined")
                          {
                            // $.ajax({
                            //   type: 'POST',
                            //   url: '/cart/change.js',
                            //   dataType: 'json',
                            //   data: {
                            //       quantity: 0,
                            //       id: attr_id
                            //   },
                            //   success: function (data){                        
                            //     jQuery('.ct_'+attr_id).closest('.cart-item').remove();
                            //   }
                            //   })
                            //alert("form "+attr_id)
                             
                          }

                      $.ajax({
                              type: 'POST',
                              url: '/cart/update.js',
                              dataType: 'json',
                               data:{
                                 attributes: {
                                       id: "47243158683970"
                                  }
                               },
                              success: function (data){
                                                                                 
                                            //jQuery('.ct_47243158683970').trigger('click');
                                            //alert("from add tocart 722");
                                            var third_attribute = 47243158683970;
                                          $("body").append('<product-form class="product-form dev_ap" style="display:none;"><div class="product-form__error-message-wrapper" role="alert" hidden=""><svg aria-hidden="true" focusable="false" class="icon icon-error" viewBox="0 0 13 13"><circle cx="6.5" cy="6.50049" r="5.5" stroke="white" stroke-width="2"></circle><circle cx="6.5" cy="6.5" r="5.5" fill="#EB001B" stroke="#EB001B" stroke-width="0.7"></circle><path d="M5.87413 3.52832L5.97439 7.57216H7.02713L7.12739 3.52832H5.87413ZM6.50076 9.66091C6.88091 9.66091 7.18169 9.37267 7.18169 9.00504C7.18169 8.63742 6.88091 8.34917 6.50076 8.34917C6.12061 8.34917 5.81982 8.63742 5.81982 9.00504C5.81982 9.37267 6.12061 9.66091 6.50076 9.66091Z" fill="white"></path><path d="M5.87413 3.17832H5.51535L5.52424 3.537L5.6245 7.58083L5.63296 7.92216H5.97439H7.02713H7.36856L7.37702 7.58083L7.47728 3.537L7.48617 3.17832H7.12739H5.87413ZM6.50076 10.0109C7.06121 10.0109 7.5317 9.57872 7.5317 9.00504C7.5317 8.43137 7.06121 7.99918 6.50076 7.99918C5.94031 7.99918 5.46982 8.43137 5.46982 9.00504C5.46982 9.57872 5.94031 10.0109 6.50076 10.0109Z" fill="white" stroke="#EB001B" stroke-width="0.7"></path></svg><span class="product-form__error-message"></span></div><form method="post" action="/cart/add" id="product-form-quickadd-template--14503160479790__main" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="'+third_attribute+'" class="product-variant-id"><div class="bold_options" ></div><div class="product-form__buttons"><button id="ProductSubmitButton-quickadd-template--14503160479790__main" type="submit" name="add" class="product-form__submit button button--full-width button--primary" aria-haspopup="dialog"><span class="dev_upsell_click">Add to cart</span><div class="loading-overlay__spinner hidden"><svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg"><circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle></svg></div></button></div></form></product-form>');
                                          $(document).find('.dev_upsell_click').trigger("click");
                                          $("body").find('.dev_ap').remove();
                                        
                            }
                          })
                          // fetch('/cart/update.js', {
                          //     method: "POST",
                          //     headers: {
                          //         'X-Requested-With': 'XMLHttpRequest',
                          //         'Content-Type': 'application/json;'
                          //     },
                          //     body: JSON.stringify({
                          //         attributes: {
                          //              id: "47243158683970"
                          //         }
                          //     })
                          // }).then((response) => {
                          //   if(cart.attributes.id != 47243158683970)
                          //   {
                            
                              
                          //   }
                          // });
                    }
                    else if(total_price < 999)
                    {
                      var attr_id=cart.attributes.id;
                        console.log("third=="+attr_id);
                      if(typeof attr_id !== "undefined")
                          {
                             jQuery('.ct_'+attr_id).trigger('click');
                          }
                        fetch('/cart/update.js', {
                            method: "POST",
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                'Content-Type': 'application/json;'
                            },
                            body: JSON.stringify({
                                attributes: {
                                     id: ""
                                }
                            })
                        })
                    }
                  }
           });
            
               
           
          }

         


          
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          //alert("dfdf");
         
           this.submitButton.classList.remove('loading');
                    if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
                    if (!this.error) this.submitButton.removeAttribute('aria-disabled');
                    this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
